import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-messaging',
  templateUrl: './error-messaging.component.html',
  styleUrls: ['./error-messaging.component.scss']
})
export class ErrorMessagingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
